import React from "react";
import { observer } from "mobx-react-lite";
import { Hooks } from "@xt/xtbase";
const { useTranslation } = Hooks;
import cx from "classnames";
import depositIcon from "@/assets/img/cfd-deposit-btn.png";
import styles from "./index.module.scss";

export type TabType = "uContract" | "fiatContract" | "spot";

interface TabSwitchProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
  onDepositClick?: () => void;
  /** 是否展示法币 tab（由 fiatCurrencyIds + IP + 余额 决策，都不命中时不展示） */
  showFiatTab?: boolean;
}

const TabSwitch: React.FC<TabSwitchProps> = ({
  activeTab,
  onTabChange,
  onDepositClick,
  showFiatTab = true,
}) => {
  const t = useTranslation();

  return (
    <div className={styles.tabSwitch}>
      <div className={styles.tabs}>
        {showFiatTab && (
          <button
            className={cx(styles.tab, { [styles.active]: activeTab === "fiatContract" })}
            onClick={() => onTabChange("fiatContract")}
          >
            {t("cfd.fiatContract")}
          </button>
        )}
        <button
          className={cx(styles.tab, { [styles.active]: activeTab === "uContract" })}
          onClick={() => onTabChange("uContract")}
        >
          {t("cfd.uContract")}
        </button>
        <button
          className={cx(styles.tab, { [styles.active]: activeTab === "spot" })}
          onClick={() => onTabChange("spot")}
        >
          {t("cfd.spot")}
        </button>
      </div>
      {onDepositClick && (
        <button type="button" className={styles.depositBtn} onClick={onDepositClick}>
          <img src={depositIcon} alt="" className={styles.depositIcon} />
        </button>
      )}
    </div>
  );
};

export default observer(TabSwitch);
